<template lang="pug">
  textarea(:ref="name") {{html}}
</template>


<script>
export default {
  props: {
    name: {
      default: 'summernote'
    },
    html:{
      default: ''
    },
    vars: {
      default: function(){
        return []
      }
    },
    airmode: {
      default: true
    }
  },
  computed: {
    summernote() {
      return $(this.$refs[this.name]);
    }
  },
  mounted() {

    var vm = this;

    var list = this.vars.map(function(item){
      return `<li data-value="{{${item}}}">${item}</li>`;
    }).join('');
    console.log(list);

    var AttributeButton = function (context) {
      var ui = $.summernote.ui;

      var button = ui.buttonGroup([
          ui.button({
              className: 'dropdown-toggle btn-variable',
              contents: 'Add Variable',
              tooltip: false,
              data: {
                  toggle: 'dropdown'
              }
          }),
          ui.dropdown({
              className: 'drop-default summernote-list',
              contents: list,
              callback: function ($dropdown) {                    
                  $dropdown.find('li').each(function () {
                      $(this).click(function () {  
                        // alert($(this).data('value'));
                          $('#summernote').summernote('editor.restoreRange');
                          $('#summernote').summernote('editor.focus');
                          $('#summernote').summernote('editor.insertText', $(this).data('value'));
                      });
                  });
              }
          }),
      ]);        

      return button.render();   // return button as jquery object 
    }

    var ActionButton = function (context) {
      var ui = $.summernote.ui;

      var button = ui.buttonGroup([
          ui.button({
              className: 'dropdown-toggle btn-variable',
              contents: 'Add Button',
              tooltip: false,
              data: {
                  toggle: 'dropdown'
              }
          }),
          ui.dropdown({
              className: 'drop-default summernote-list',
              contents: `<li data-value="#3490dc">Primary</li>
                         <li data-value="#38c172">Success</li>
                         <li data-value="#e3342f">Error</li>`,
              callback: function ($dropdown) {                    
                  $dropdown.find('li').each(function () {
                      $(this).click(function () {  
                        // alert($(this).data('value'));
                        var html = `<div style="margin: 30px auto; padding: 0; text-align: center; width: 100%; -premailer-cellpadding: 0; -premailer-cellspacing: 0; -premailer-width: 100%;"><a style="border-radius: 3px; box-shadow: 0 2px 3px rgba(0, 0, 0, 0.16); color: #fff; display: inline-block; text-decoration: none; -webkit-text-size-adjust: none; padding: 10px; background-color:${ $(this).data('value') };" href="{{url}}" target="_blank"> Button </a></div>`
                          $('#summernote').summernote('editor.restoreRange');
                          $('#summernote').summernote('editor.focus');
                          $('#summernote').summernote('editor.pasteHTML', html);
                      });
                  });
              }
          }),
      ]);        

      return button.render();   // return button as jquery object 
    }


    $(this.$refs[this.name]).summernote({
      height: 300,
      airMode: vm.airmode,
      tooltip: false,
      toolbar: [
        // ['style', ['style']],
        ['font', ['bold', 'underline', 'clear']],
        ['color', ['color']],
        ['fontname', ['fontname']],
        ['para', ['ul', 'ol', 'paragraph']],
        ['insert', ['link']],
        ['table', ['table']],
        // ['attribute', ['btnVars', 'atnBtn']]
      ],
      fontNames: ['Poppins'],
      popover: {
        link: [
          ['link', ['linkDialogShow', 'unlink']]
        ],
        table: [
          ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
          ['delete', ['deleteRow', 'deleteCol', 'deleteTable']],
        ],
        air: [
          // ['style', ['style']],
          ['font', ['bold', 'underline', 'clear']],
          // ['fontname', ['fontname']],
          ['color', ['color']],
          ['para', ['ul', 'ol', 'paragraph']],
          ['insert', ['link']],
          ['table', ['table']],
          // ['attribute', ['btnVars', 'atnBtn']]
        ]
      },
      buttons: {
        btnVars: AttributeButton,
        atnBtn: ActionButton,
      },
      onCreateLink : function(originalLink) {
        return originalLink; // return original link 
      },
      callbacks: {
        onPaste: function (e) {
          var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');

          e.preventDefault();

          // Firefox fix
          setTimeout(function () {
              document.execCommand('insertText', false, bufferText);
          }, 10);
        }
      }
    });

    $(this.$refs[this.name]).summernote('fontName', 'Poppins');
  },

  created() {
    this.summernote.summernote({
      heigh: 300,
      tooltip: false
    })
  },
  methods: {
    setVal(val){
      $(this.$refs[this.name]).summernote('code', val);
    },
    getVal() {
      var data  = $(this.$refs[this.name]).summernote('code');
      return data;
    },
    run(code, value) {
      if(value == undefined) {
        $(this.$refs[this.name]).summernote(code)
      }else {
        $(this.$refs[this.name]).summernote(code,value)
      }
    }
  }
}
</script>

